import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk'
import { useEffect, useState } from 'react'

export type LDSafeFlags = 'error' | undefined | Record<string, unknown>

/**
 * This is a wrapper around the base launch darkly useFlags hook so we
 * can retrieve the status of launch darkly's loaded state
 *
 * @returns undefined if launch darkly is loading, 'error' if launch
 * darkly fails to load, and the flags if launch darkly is loaded
 */
export const useLDSafeFlags = (): LDSafeFlags => {
  const flags = useFlags()

  const [state, setState] = useState<'error' | 'finished' | 'loading'>('loading')

  // Wait for launch darkly to initialize
  const ldClient = useLDClient()
  useEffect(() => {
    // Wait for the client to be initialized or errored and then set it in our redux state
    const initLdClient = async () => {
      try {
        await ldClient?.waitForInitialization()
        setState('finished')
      } catch {
        setState('error')
      }
    }
    initLdClient()
  }, [ldClient, setState])

  if (state === 'loading') {
    return undefined
  } else if (state === 'error') {
    return 'error'
  } else {
    return flags
  }
}
